<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Product from '@/components/widgets/product'
import ProductService from '@/services/product'

export default {
  page: {
    title: "Produtos",
  },
  components: { Layout, PageHeader, Product },
  data() {
    return {
      title: "Produtos",
      products: [],
      searchValue: '',

      count: 0,
      currentCount: 0,
      currentPage: 1,
      totalPages: 0,
      perPage: 0,
      startIndex: 0,
      endIndex: 0,
    }
  },
  computed: {
    rows() {
      return this.products.length;
    }
  },
  mounted() {
    this.load(1);
  },
  methods: {
    load(page) {
      let loader = this.$loading.show();

      ProductService.getAllProducts(page, this.searchValue).then(res => {
        loader.hide();

        this.products = res.data.data;

        this.count = res.data.count;
        this.currentCount = res.data.currentCount;
        this.currentPage = res.data.currentPage;
        this.totalPages = res.data.totalPages;
        this.perPage = res.data.perPage;
        this.startIndex = res.data.startIndex;
        this.endIndex = res.data.endIndex;
      }).catch(() => {
        loader.hide();
      })
    },
    onPageChange() {
      this.load(this.currentPage);
    },
    search() {
      this.load(1);
    },
    changeSearch() {
      if (this.searchValue === '' && !this.searchEmptyField) {
        this.searchEmptyField = true;
        this.load(true, 1, this.searchValue);
      }
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-6">
                <div class="position-relative search-input search-box">
                  <form @submit.prevent="search" class="align-items-center">
                    <input
                      type="text"
                      class="form-control"
                      v-model="searchValue"
                      placeholder="Procurar por código ou descrição..."
                    />

                    <button type="submit" class="btn btn-rounded btn-outline-primary ml-2">
                      Pesquisar
                    </button>
                  </form>
                </div>
              </div>
              <div class="col-6">
                <div class="text-right">
                  <router-link to="/products/edit">
                    <button type="button" class="btn btn-primary btn-rounded mb-2 mr-2">
                      <i class="mdi mdi-plus mr-1"></i> Novo Produto
                    </button>
                  </router-link>
                </div>
              </div>
              <!-- end col-->
            </div>
            <!-- Table data -->
            <Product :products="products" :loadProducts="this.load" />
            
            <div class="row justify-content-md-between align-items-md-center mt-4">
              <div class="col-xl-7">Mostrando {{startIndex}} - {{endIndex}} de {{count}}</div>

              <div class="col-xl-5">
                <div class="text-md-right float-xl-right mt-2 pagination-rounded">
                  <b-pagination
                    v-model="currentPage" 
                    :total-rows="count"
                    :per-page="perPage"
                    @input="onPageChange"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    <!-- <div class="row" v-if="loading">
      <div class="col-12">
        <div class="text-center my-3">
          <a href="javascript:void(0);" class="text-primary">
            <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
          </a>
        </div>
      </div>
    </div> -->
  </Layout>
</template>

<style lang="scss">
  .search-box form {
    display: flex;
    flex-direction: row;
  }

  .search-box .form-control {
    padding-left: 20px;
  }

  .input-search {
    width: 90%;
  }
</style>